class FSTransactionEntity {
  constructor() {
    this.date = null;
    this.description = null;
    this.type = null;
    this.tag = null;
    this.amount = null;
    this.posted = null;
  }
}

export default FSTransactionEntity;
